<div id="set-password" class="float-panel lg-form-container" fxLayout="column" ngcPerfectScrollbar>
    <div id="set-password-form-wrapper" class="lg-form-wrapper" fxLayout="column" fxLayoutAlign="center center" *ngcIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

        <div *ngIf="changePasswordAllowed" id="set-password-form" class="lg-form">
            <mat-progress-bar *ngIf="loading | async" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

            <div class="title">SETUP YOUR PASSWORD</div>

            <form name="passwordForm" [formGroup]="passwordForm" #formDirective="ngForm" novalidate (ngSubmit)="formSubmit(passwordForm, formDirective)">

                <div>
                    <ngc-password [userEmail]="'unknown'"
                                  [passwordCtrl]="passwordForm.controls.password"
                                  [confirmPasswordCtrl]="passwordForm.controls.confirmPassword"
                                  [isConfirmPassword]="false"
                                  [isVertical]="isVertical"
                                  [required]="true"
                                  [hidePassword$]="hidePassword$"
                    >
                    </ngc-password>
                </div>

                <div>
                    <ngc-password [userEmail]="'unknown'"
                                  [passwordCtrl]="passwordForm.controls.confirmPassword"
                                  [isConfirmPassword]="true"
                                  [isVertical]="isVertical"
                                  [required]="true"
                                  [hidePassword$]="hidePassword$"
                                  [hasPasswordErrors]="passwordForm?.controls?.password?.errors"
                    >
                    </ngc-password>
                </div>

                <ul class="errors" *ngIf="errorMessages">
                    <li *ngFor="let message of errorMessages">{{message}}</li>
                </ul>

                <div class="password-strength-info secondary-text">
                    {{PASSWORD_STRENGTH_INFO}}
                </div>

                <button type="submit"
                        mat-raised-button
                        class="submit-button"
                        color="accent"
                        aria-label="SUBMIT"
                        [disabled]="passwordForm.invalid"
                        tabindex="6"
                >
                    SUBMIT
                </button>
            </form>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'/login'">Go to sign in</a>
            </div>

        </div>

        <div *ngIf="!changePasswordAllowed" class="lg-form">
            <div class="logo" alt="logo"></div>

            <h1>{{preMessage}}</h1>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
<!--                <a *ngIf="!changePasswordLinkExpired" class="link" [routerLink]="'/login'">Go to sign in</a>-->
                <a *ngIf="changePasswordLinkExpired" class="link" [routerLink]="'/auth/forgot-password'">Forgot Password?</a>
                <button *ngIf="!changePasswordLinkExpired" mat-raised-button color="accent" class="mt-8" (click)="getNewLink()">
                    Get a new link
                </button>
            </div>
        </div>

    </div>
    <ngc-footer-page *ngcIfOnDom [textColor]="'white'"></ngc-footer-page>
</div>
